import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { stringJoin } from "../../../../utils/functions";
import { LinkAnchors, ProductsLink } from "../../../../utils/links";
import DetailImage from "./assets/darkhr.png";
import InstagramIcon from "../../../images/social/InstagramIcon";
import FacebookIcon from "../../../images/social/FacebookIcon";
import TwitterXIcon from "../../../images/social/TwitterXIcon";
import YoutubeIcon from "../../../images/social/YoutubeIcon";

import * as Styles from "./footer.module.scss";

interface FooterProps {
    products: readonly Queries.BeerFragment[];
}

const MainFooter: React.FC<FooterProps> = ({ products }) => {

    return (
        <footer className={stringJoin("mt-auto text-center text-white pb-3", Styles.footer)}>
            <Container>
                <Row className="align-items-start row-cols-1 row-cols-lg-4 mt-5 pb-3 g-0 text-uppercase">
                    <Col lg={6} className="d-flex flex-column mb-3 pe-lg-5 gap-2 text-center text-lg-start">
                        <div className={stringJoin("text-center text-lg-start", Styles.productCol)}>
                        {["Heritage", "Cream Ale", "Specialty", "Vault"].map((category) => (
                            <div className="mb-3 break-inside-avoid" key={category}>
                            <p className="mb-0 opacity-50" style={{ letterSpacing: "0.5em" }}>{category}</p>
                            {products.filter((node) => node.category === category).map((node) => (
                            <Link key={node.slug} to={ProductsLink(node?.slug)} className="py-1 d-block">{node?.name}</Link>
                            ))}
                            </div>
                        ))}
                        </div>
                    </Col>
                    <Col className="d-flex flex-column mb-3 gap-2 text-center text-lg-start">
                        <Link to={LinkAnchors.DISTINCTION}>Beers of Distinction</Link>
                        <Link to={LinkAnchors.FINDER}>Beer Finder</Link>
                        <Link to={LinkAnchors.ABOUT}>About</Link>
                        <Link to={LinkAnchors.VAULT}>Vault</Link>
                        <Link to={LinkAnchors.BREWHOUSE}>Genesee Brewhouse</Link>
                        <OutboundLink href="https://store.geneseebeer.com/" target="_blank">
                            Genesee Gear
                        </OutboundLink>
                        <Link to={LinkAnchors.NEWSLETTER}>Newsletter Sign Up</Link>
                    </Col>
                    <Col className="d-flex flex-column mb-3 gap-2 text-center text-lg-start">
                        <OutboundLink href="https://www.fifcousa.com/careers/" target="_blank">
                            Careers
                        </OutboundLink>
                        <OutboundLink href="https://www.fifcousa.com/privacy-policy/" target="_blank">
                            Privacy Policy
                        </OutboundLink>
                        <OutboundLink href="https://www.fifcousa.com/terms/" target="_blank">
                            Terms & Conditions
                        </OutboundLink>
                        <OutboundLink href="https://www.fifcousa.com/ctsc-disclosure/" target="_blank">
                            CSCA
                        </OutboundLink>
                        <OutboundLink href="https://www.fifcousa.com/privacy-policy/#fifco-ccpa-optout" target="_blank">
                            CCPA Request to Opt-Out
                        </OutboundLink>
                        <Link to={LinkAnchors.NUTRITIONAL}>Nutritional Info</Link>
                        <Link to={LinkAnchors.CONTACT}>Contact</Link>
                    </Col>
                </Row>
                <Row className="w-100 g-0">
                    <Col className="text-center">
                        <img src={DetailImage} alt="Detail Image" className="mb-3" />
                        <ul className="d-flex justify-content-center list-unstyled">
                            <li className="mx-2">
                                <OutboundLink href="https://facebook.com/geneseebrewery/?utm_source=geneseebeer.com&utm_medium=referral" target="_blank" aria-label="Genesee Brewery on Facebook">
                                    <FacebookIcon />
                                </OutboundLink>
                            </li>
                            <li className="mx-2">
                                <OutboundLink href="https://instagram.com/geneseebrewery/?utm_source=geneseebeer.com&utm_medium=referral" target="_blank" aria-label="Genesee Brewery on Instagram">
                                    <InstagramIcon />
                                </OutboundLink>
                            </li>
                            <li className="mx-2">
                                <OutboundLink href="https://twitter.com/GeneseeBrewery/?utm_source=geneseebeer.com&utm_medium=referral" target="_blank" aria-label="Genesee Brewery on Twitter X">
                                    <TwitterXIcon />
                                </OutboundLink>
                            </li>
                            <li className="mx-2">
                                <OutboundLink href="https://www.youtube.com/channel/UC2O4zcFt859XGzcatVbmPOA/?utm_source=geneseebeer.com&utm_medium=referral" target="_blank" aria-label="Genesee Brewery on YouTube">
                                    <YoutubeIcon />
                                </OutboundLink>
                            </li>
                        </ul>
                        <span className="fs-5 lh-1">
                            EST. 1878
                            <br />© 2025 The Genesee Brewery
                        </span>
                        <br />
                        <small>
                            All rights reserved. Always drink responsibly.
                            <br />
                            The Genesee Brewing Co. is owned by FIFCO USA. For more information, please go to:{" "}
                            <OutboundLink href="https://fifcousa.com" target="_blank">
                                fifcousa.com
                            </OutboundLink>
                        </small>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default MainFooter;
